import { render, staticRenderFns } from "./ServiceTakerAllocationPage.vue?vue&type=template&id=3d09d237&"
import script from "./ServiceTakerAllocationPage.vue?vue&type=script&lang=js&"
export * from "./ServiceTakerAllocationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports